module.exports = __webpack_public_path__ + "static/media/icon_news_b.b36b4e4f.svg";